import { useLoyaltyContext } from '../loyalty-context';

import type { LoyaltyUser } from './types';

export const useLoyaltyUser = (): {
  loyaltyUser: LoyaltyUser | null;
  loading: boolean;
  loyaltyUserId: string;
} => {
  const { loyaltyUser, loading } = useLoyaltyContext();
  const loyaltyUserId = loyaltyUser?.id;

  return {
    loyaltyUser,
    loading,
    loyaltyUserId,
  };
};
